export const GET_ALL_LABTESTATTRIBUTE = "GET_ALL_LABTESTATTRIBUTE";
export const GET_LABTESTATTRIBUTE_FOR_ORDER = "GET_LABTESTATTRIBUTE_FOR_ORDER";
export const GET_LABTEST_RESULTS = "GET_LABTEST_RESULTS"
